<footer class="main-footer">
        <!-- To the right -->
        <div class="pull-right hidden-xs">
            {{ versaoNumero }}
        </div>
        <!-- Default to the left -->
        <strong>Copyright &copy; {{ anoAtual }} <a href="#" class="smo">SMO - Segurança e Medicina Ocupacional S/C</a>.</strong> Todos os direitos reservados.
    </footer>